/* eslint no-nested-ternary: 0 */
import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import { Form, Button, FormGroup, Input, Label, Col, Collapse, Badge } from 'reactstrap';
// import 'react-select/dist/react-select.css';

const optionStyles = {
  // control: styles => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data: { precaucion }, isFocused, isSelected }) => {
    // if not precaucion, use default style
    if (!precaucion) {
      return { ...styles };
    }
    return {
      ...styles,
      color: isSelected || isFocused ? 'white' : 'inherit',
      backgroundColor: isSelected
        ? 'rgba(215, 44, 44, 0.6)'
        : isFocused
          ? 'rgba(215, 44, 44, 0.4)'
          : 'rgba(215, 44, 44, 0.2)'
    };
  }
};

class SelectInput extends React.Component {
  static getDerivedStateFromProps(props) {
    const { options = [] } = props;
    if (!options || options.length === 0) {
      return { options: [] };
    }
    const optionsToShow = props.options.map(item => ({
      ...item,
      value: item.selectedOption ? item.selectedOption.nombre : item.nombre,
      label: item.selectedOption ? item.selectedOption.nombre : item.nombre
    }));
    return { options: optionsToShow };
  }
  state = {
    showInput: false,
    selectedOption: '',
    cantidad: 1,
    horas: 0,
    potencia: 0,
    nombre: ''
  };

  sendOption = () => {
    // and change global
    const { selectedOption, cantidad, horas, nombre, potencia } = this.state;
    return this.props.onSelect({ selectedOption, cantidad, horas, nombre, potencia }).then(() =>
      this.setState({
        selectedOption: '',
        cantidad: 1,
        horas: 0,
        nombre: '',
        potencia: 0
      })
    );
  };

  handleChange = selectedOption => this.setState({ selectedOption });

  formatGroupLabel = data => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span style={{ paddingBottom: '0.5rem' }}>
        {data.label ? data.label : 'No identificadas'}
      </span>
      <Badge color="light" pill style={{ fontSize: '0.8rem' }}>
        {data.options.length}
      </Badge>
    </div>
  );

  render() {
    const { selectedOption, cantidad, horas, options, nombre, potencia, showInput } = this.state;
    const groupLabels = _.uniqBy(options, 'grupo').map(item => item.grupo);
    const sortedLabels = _.sortBy(groupLabels);
    const groups = _.groupBy(options, 'grupo');
    const groupedOptions = sortedLabels.map(label => ({
      label,
      options: groups[label]
    }));

    return (
      <React.Fragment>
        <Collapse isOpen={!showInput}>
          <React.Fragment>
            <Select
              name="form-field-name"
              placeholder="Busca un equipo..."
              value={selectedOption}
              onChange={this.handleChange}
              options={groupedOptions}
              styles={optionStyles}
              formatGroupLabel={this.formatGroupLabel}
            />
            {selectedOption &&
              selectedOption.precaucion && (
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '0.8rem',
                    fontWeight: 700,
                    padding: '0.25rem 0',
                    color: 'crimson'
                  }}
                >
                  <div>Artículo no recomendado debido a su consumo energético</div>
                </div>
              )}

            <Form>
              <FormGroup row>
                <Col xs={12} sm={6} style={{ margin: '0.5rem 0' }}>
                  <Label for="cantidadInput">Cantidad</Label>
                  <Input
                    type="number"
                    placeholder="Cantidad"
                    id="cantidadInput"
                    min={0}
                    value={cantidad}
                    onChange={e => this.setState({ cantidad: e.target.value })}
                  />
                </Col>
                <Col xs={12} sm={6} style={{ margin: '0.5rem 0' }}>
                  <Label for="hoursInput">Horas de Uso</Label>
                  <Input
                    type="number"
                    placeholder="Horas"
                    id="hoursInput"
                    min={0}
                    max={24}
                    value={horas}
                    onChange={e => this.setState({ horas: e.target.value })}
                  />
                </Col>
              </FormGroup>
            </Form>
            <Button
              block
              color="primary"
              className="btn g-font-weight-600 g-font-size-13 text-uppercase rounded-3 g-py-12 g-px-35"
              onClick={this.sendOption}
            >
              Agregar
            </Button>
          </React.Fragment>
        </Collapse>
        {!showInput && (
          <div style={{ fontSize: '1rem', textAlign: 'center', marginBottom: '1rem' }}>
            {' '}
            <hr style={{ marginBottom: '1rem' }} /> O también puedes{' '}
          </div>
        )}

        <Button
          block
          className="bg-sp-blue btn g-font-weight-600 g-font-size-13 "
          onClick={() => this.setState({ showInput: !this.state.showInput })}
        >
          {showInput ? 'Volver a Lista de equipos' : 'Ingresar tu propio Equipo'}
        </Button>
        <Collapse isOpen={showInput}>
          <Form>
            <FormGroup row>
              <Col xs={12} style={{ margin: '0.5rem 0' }}>
                <Label for="cantidadInput">Equipo</Label>
                <Input
                  placeholder="Nombre"
                  value={nombre}
                  onChange={e => this.setState({ nombre: e.target.value })}
                />
              </Col>
              <Col xs={12} sm={4}>
                <Label for="cantidadInput" style={{ fontSize: '0.85rem' }}>
                  Cantidad
                </Label>
                <Input
                  type="number"
                  placeholder="Cantidad"
                  id="cantidadInput"
                  min={0}
                  value={cantidad}
                  onChange={e => this.setState({ cantidad: e.target.value })}
                />
              </Col>
              <Col xs={12} sm={4}>
                <Label for="potenciaInput" style={{ fontSize: '0.85rem' }}>
                  Potencia W
                </Label>
                <Input
                  type="number"
                  placeholder="Potencia"
                  id="potenciaInput"
                  min={0}
                  value={potencia}
                  onChange={e => this.setState({ potencia: e.target.value })}
                />
              </Col>
              <Col xs={12} sm={4}>
                <Label for="hoursInput" style={{ fontSize: '0.85rem' }}>
                  Hrs. de Uso
                </Label>
                <Input
                  type="number"
                  placeholder="Horas"
                  id="hoursInput"
                  min={0}
                  max={24}
                  value={horas}
                  onChange={e => this.setState({ horas: e.target.value })}
                />
              </Col>
            </FormGroup>
          </Form>
          <Button block color="primary" onClick={this.sendOption}>
            Agregar
          </Button>
        </Collapse>
      </React.Fragment>
    );
  }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/Home/CalculadoraConsumo/SelectInput.js